// Constantes compartidas entre las secciones de administración de puntaje
// (ScoringParametersSection, ScoringTemplatesPage, resultados) — un solo
// lugar que sabe qué campos de configuración aplican a cada uno de los 6
// parameterType, para no duplicar ese mapeo en cada formulario. Ver
// platforms/api/src/services/cccd-scoring.ts para las fórmulas exactas.

export type CccdParameterType =
  | 'numeric_value'
  | 'calculated_height'
  | 'height_with_max_error'
  | 'height_with_perfect_band'
  | 'flight_time'
  | 'yes_no_parameter';

export const PARAMETER_TYPES: CccdParameterType[] = [
  'numeric_value',
  'calculated_height',
  'height_with_max_error',
  'height_with_perfect_band',
  'flight_time',
  'yes_no_parameter',
];

export const PARAMETER_TYPE_LABELS: Record<CccdParameterType, string> = {
  numeric_value: 'Valor numérico',
  calculated_height: 'Altura calculada (trigonometría)',
  height_with_max_error: 'Altura con error máximo',
  height_with_perfect_band: 'Altura con banda perfecta',
  flight_time: 'Tiempo de vuelo',
  yes_no_parameter: 'Sí / No',
};

export type ConfigField = 'maxScore' | 'targetHeight' | 'maxError' | 'perfectBand' | 'minTime' | 'maxTime' | 'tolerance' | 'maxValue';

export const CONFIG_FIELD_LABELS: Record<ConfigField, string> = {
  maxScore: 'Puntaje máximo',
  targetHeight: 'Altura objetivo (m)',
  maxError: 'Error máximo (m o %)',
  perfectBand: 'Banda perfecta (%)',
  minTime: 'Tiempo mínimo (s)',
  maxTime: 'Tiempo máximo (s)',
  tolerance: 'Tolerancia (s)',
  maxValue: 'Valor si "Sí"',
};

// Explicación en lenguaje simple de qué significa cada campo — se muestra
// como texto de ayuda debajo del campo en el formulario "amigable" de
// creación/edición (cccd-scoring-ux-redesign, /cccd/scoring-parameters/new).
export const CONFIG_FIELD_HELP: Record<ConfigField, string> = {
  maxScore: 'El total de puntos que puede ganar un equipo en este parámetro.',
  targetHeight: 'La altura que se espera que el equipo alcance.',
  maxError: 'Qué tan lejos del objetivo puede caer el equipo antes de quedarse en 0 puntos.',
  perfectBand: 'Qué tan cerca del objetivo del motor debe caer para llevarse el puntaje completo, sin perder nada.',
  minTime: 'El tiempo de vuelo más corto que todavía cuenta como bueno.',
  maxTime: 'El tiempo de vuelo más largo que todavía cuenta como bueno.',
  tolerance: 'Qué tan lejos de ese rango puede caer el vuelo antes de llegar a 0 puntos.',
  maxValue: 'Los puntos que gana el equipo si la respuesta es "Sí".',
};

// Qué campos de configuración aplican a cada tipo — maneja tanto el
// formulario de parámetro/plantilla como la validación de completitud antes
// de guardar.
export const PARAMETER_TYPE_CONFIG_FIELDS: Record<CccdParameterType, ConfigField[]> = {
  numeric_value: [],
  calculated_height: ['maxScore'],
  height_with_max_error: ['targetHeight', 'maxError', 'maxScore'],
  height_with_perfect_band: ['perfectBand', 'maxError', 'maxScore'],
  flight_time: ['minTime', 'maxTime', 'tolerance', 'maxScore'],
  yes_no_parameter: ['maxValue'],
};
